/**
 * @voltxampere/ui — 2N7000 NMOS MOSFET variant (Sprint 38-2)
 *
 * Reference: onsemi 2N7000 datasheet (TO-92 small-signal NMOS).
 *   Vt0 = 2.0 V         (typical gate threshold)
 *   Kp  = 0.118 A/V²    (transconductance @ V_GS = 4.5 V)
 *   Lambda = 0.005 1/V  (low channel-length modulation, signal device)
 *
 * Engine zero-diff invariant honored — variant maps to canonical
 * `mosfet-nmos` engine stamp (Sprint 7).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { nmos } from "../nmos.js";
export const mosfetNmos2n7000 = {
    id: "2n7000",
    nameTr: "2N7000 (NMOS, TO92)",
    nameEn: "2N7000 (NMOS, TO92)",
    shortcut: "M",
    category: "active",
    viewBox: nmos.viewBox,
    terminals: nmos.terminals,
    defaultLabel: "M",
    defaultValue: "2N7000",
    schemaType: "mosfet-nmos",
    defaultParams: { Vt0: 2.0, Kp: 0.118, Lambda: 0.005 },
    renderSVG: () => nmos.renderSVG(),
};
//# sourceMappingURL=mosfet-nmos-2n7000.js.map